<script setup lang="ts">
  import { MpText } from '@borg/ui';

  const { t } = useI18n();
  const jobCard = useJobCard.inject();

  const displayString = computed(() =>
    getWorkTypeLocationString(jobCard.job?.workTypes ?? [], jobCard.job?.location ?? '', t),
  );
</script>

<template>
  <MpText
    v-if="displayString"
    no-margin
  >
    {{ displayString }}
  </MpText>
</template>
